import styled from 'styled-components';
interface StyledProps {
  zIndex?: number;
}
export const FloatingContainer = styled.div.attrs<any, StyledProps>({})`
  position: fixed;
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 2)};
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  bottom: 32px;
  right: 32px;
  border-radius: 28px;
  background: ${({ theme }) => theme.floatingActionButton.background};
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`;
